import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { MessageCircle, Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="/logo.png" 
              alt="Volaille Prime" 
              className="h-12 w-auto"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <div>
              <h1 className="text-2xl font-bold text-burgundy">Volaille Prime</h1>
              <p className="text-xs text-gold font-medium">Goût. Fraîcheur. Confiance.</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link 
              to="/"
              className={`font-medium transition-colors ${
                isActive('/') ? 'text-burgundy' : 'text-gray-700 hover:text-burgundy'
              }`}
            >
              Accueil
            </Link>
            <Link 
              to="/produits"
              className={`font-medium transition-colors ${
                isActive('/produits') ? 'text-burgundy' : 'text-gray-700 hover:text-burgundy'
              }`}
            >
              Produits & Commande
            </Link>
            <Link 
              to="/a-propos"
              className={`font-medium transition-colors ${
                isActive('/a-propos') ? 'text-burgundy' : 'text-gray-700 hover:text-burgundy'
              }`}
            >
              À propos
            </Link>
            <Link 
              to="/contact"
              className={`font-medium transition-colors ${
                isActive('/contact') ? 'text-burgundy' : 'text-gray-700 hover:text-burgundy'
              }`}
            >
              Contact
            </Link>
            <a 
              href="https://wa.me/221781270846"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-burgundy hover:bg-burgundy-dark text-white gap-2">
                <MessageCircle size={18} />
                WhatsApp
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-burgundy"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-4 border-t border-gray-200 pt-4">
            <Link 
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-left font-medium transition-colors ${
                isActive('/') ? 'text-burgundy' : 'text-gray-700 hover:text-burgundy'
              }`}
            >
              Accueil
            </Link>
            <Link 
              to="/produits"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-left font-medium transition-colors ${
                isActive('/produits') ? 'text-burgundy' : 'text-gray-700 hover:text-burgundy'
              }`}
            >
              Produits & Commande
            </Link>
            <Link 
              to="/a-propos"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-left font-medium transition-colors ${
                isActive('/a-propos') ? 'text-burgundy' : 'text-gray-700 hover:text-burgundy'
              }`}
            >
              À propos
            </Link>
            <Link 
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`text-left font-medium transition-colors ${
                isActive('/contact') ? 'text-burgundy' : 'text-gray-700 hover:text-burgundy'
              }`}
            >
              Contact
            </Link>
            <a 
              href="https://wa.me/221781270846"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              <Button className="w-full bg-burgundy hover:bg-burgundy-dark text-white gap-2">
                <MessageCircle size={18} />
                WhatsApp
              </Button>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
